/**
 * Redirect the member to the payment gateway by auto-submitting a hidden form.
 *
 * @param {string} actionUrl Gateway URL (payment_portal_url)
 * @param {Record<string, string|number>} fields Form fields (e.g. { TransactionID: "..." })
 * @param {"POST"|"GET"|string} [method="POST"]
 */
export function submitPaymentForm(actionUrl, fields = {}, method = "POST") {
  if (!actionUrl) {
    throw new Error("Payment portal URL is missing.");
  }

  const form = document.createElement("form");
  form.method = String(method || "POST").toUpperCase();
  form.action = actionUrl;
  form.style.display = "none";
  form.setAttribute("accept-charset", "UTF-8");

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value == null ? "" : String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
